module.exports = __webpack_public_path__ + "static/media/token-preview-hearts-neon.0ebd4078.png";